<template>
  <svg width="14"
       height="20"
       viewBox="0 0 14 20"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M7 13.0889C8.98633 13.0889 10.375 11.6035 10.375 9.47656V4.00977C10.375 1.88281 8.98633 0.397461 7 0.397461C5.02246 0.397461 3.625 1.88281 3.625 4.00977V9.47656C3.625 11.6035 5.02246 13.0889 7 13.0889ZM7 11.4629C5.97168 11.4629 5.32129 10.6719 5.32129 9.51172V3.97461C5.32129 2.81445 5.97168 2.02344 7 2.02344C8.02832 2.02344 8.67871 2.81445 8.67871 3.97461V9.51172C8.67871 10.6719 8.02832 11.4629 7 11.4629ZM2.95703 19.7861H11.043C11.5088 19.7861 11.8955 19.4082 11.8955 18.9512C11.8955 18.4854 11.5088 18.1162 11.043 18.1162H7.81738V16.332C11.2891 15.998 13.7148 13.5107 13.7148 9.87207V8.14062C13.7148 7.6748 13.3457 7.31445 12.8799 7.31445C12.4141 7.31445 12.0273 7.6748 12.0273 8.14062V9.81055C12.0273 12.8076 9.99707 14.7764 7 14.7764C4.00293 14.7764 1.97266 12.8076 1.97266 9.81055V8.14062C1.97266 7.6748 1.59473 7.31445 1.12891 7.31445C0.663086 7.31445 0.285156 7.6748 0.285156 8.14062V9.87207C0.285156 13.5107 2.71094 15.998 6.18262 16.332V18.1162H2.95703C2.49121 18.1162 2.10449 18.4854 2.10449 18.9512C2.10449 19.4082 2.49121 19.7861 2.95703 19.7861Z"
          :fill="color"/>
  </svg>

</template>

<script>
export default {
  name: 'MicrophoneIcon',
  props: {
    color: {
      type: String,
      default: '#01CFE4'
    }
  }

}
</script>

<style>

</style>
